// import variables from '../variables';
/* eslint-disable */
const MuiMenuItem = {
  root: {
    marginBottom: 0,
  },
};

export default MuiMenuItem;
